import { Component, OnInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-widget-test',
  standalone: false,
  templateUrl: './widget-test.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-test.component.css'
})
export class WidgetTestComponent implements OnInit {
  baseUrl = window.location.origin;
  iframeSimpleUrl!: SafeResourceUrl;
  iframeAdvancedUrl!: SafeResourceUrl;
  iframeShortTermQualityUrl!: SafeResourceUrl;
  iframeParkAndFlyQualityUrl!: SafeResourceUrl;
  iframeShortTermAidenUrl!: SafeResourceUrl;
  iframeParkAndFlyAidenUrl!: SafeResourceUrl;
  iframeQualityLandingUrl!: SafeResourceUrl;
  iframeAidenLandingUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.iframeSimpleUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/simple-widget-booking?orgId=DC3E5C36-A4F7-4886-98F2-4833EA27F84B`
    );
    this.iframeAdvancedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/advanced-widget-booking`
    );
    this.iframeShortTermQualityUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/app-short-term-widget`
    );
    this.iframeParkAndFlyQualityUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/park-and-fly-advanced-widget-booking`
    );
    this.iframeShortTermAidenUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/app-aiden-short-term-widget`
    );
    this.iframeParkAndFlyAidenUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/aiden-park-and-fly-advanced-widget-booking`
    );
    this.iframeQualityLandingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/parkifly/quality-landing-page?public=true`
    );
    this.iframeAidenLandingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/parkifly/aiden-landing-page`
    );
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data && event.data.type === 'parkifly-resize-widget') {
      const height = event.data.height;
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        if (iframe.contentWindow === event.source) {
          (iframe as HTMLElement).style.height = `${height}px`;
        }
      });
    }
  }

  ngAfterViewInit() {
    setInterval(() => {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe, idx) => {
        try {
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          console.log(`[Diagnostic] Iframe #${idx} (${iframe.src}):`, {
            href: iframe.contentWindow?.location.href,
            bodyLength: doc?.body?.innerHTML?.length || 0,
            bodySnippet: doc?.body?.innerHTML?.substring(0, 200) || 'empty'
          });
        } catch (e) {
          console.log(`[Diagnostic] Iframe #${idx} (${iframe.src}) error:`, e);
        }
      });
    }, 4000);
  }
}